
export default class Main {

    constructor(){
        this.player = null;
        this.$voice = document.querySelector('.special_hd2024__voice');
        this.$playbtn = document.querySelector('.js-voice__playbtn');
        this._init();
    }

    _init(){
        this.player = videojs('js-voice__brightcove');
        this.player.ready(this._playerReady.bind(this));

        window.addEventListener('blur', this._onBlur.bind(this));
        window.addEventListener('focus', this._onFocus.bind(this));
        document.addEventListener('visibilitychange', this._onVisibilityChange.bind(this));
    }


    _playerReady(){
        this.player.audioOnlyMode(true);

        this.player.on('ended', ()=>{
            this.$voice.classList.remove('-playing');
        });

        this.$playbtn.addEventListener('click', ()=>{
            
            if(!this.$voice.classList.contains('-playing')){
                this.player.play();
            }
            else{
                this.player.pause();
            }

            this.$voice.classList.toggle('-playing');
        });
    }

    _onBlur(){
        this.lastEvent = 'blur';
        this._pause();
    }

    _onFocus(){
        this.lastEvent = 'focus';
        this._resume();
    }

    _onVisibilityChange(){

        if(document.hidden){
            if(this.lastEvent !== 'blur') this._pause();
        }
        else{
            if(this.lastEvent !== 'focus') this._resume();
        }

        this.lastEvent = null;
    }

    _pause(){
        if(!this.player) return;
        this.player.pause();
        this.$voice.classList.remove('-playing');
    }

    _resume(){
    }
}   
